import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { NgbTimepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { EPrescribeComponentModule } from "components/eprescribe/eprescribe.component.module";
import { CareLocationTypeComponent } from "components/order-management/care-location-type/care-location-type";
import { CareLocationComponent } from "components/order-management/care-location/care-location";
import { VerificationComponent } from "components/order-management/checkbox/checkbox";
import { CurrentDiagnosisComponent } from "components/order-management/current-diagnosis/current-diagnosis";
import { DatePickerComponent } from "components/order-management/date-picker/date-picker";
import { OrderingSearchInputComponent } from "components/order-management/diagnosis-search/diagnosis-search";
import { DisciplineComponent } from "components/order-management/discipline/discipline";
import { OrderingDropdownComponent } from "components/order-management/dropdown/dropdown";
import { FileUploadComponent } from "components/order-management/file-upload/file-upload";
import { LevelOfCareComponent } from "components/order-management/level-of-care/level-of-care";
import { MARDetailsComponent } from "components/order-management/mar-details/mar-details";
import { MedicationIngredientsScriptsureComponent } from "components/order-management/medication-ingredients-scriptsure/medication-ingredients-scriptsure";
import { MedicationNameDescriptionScriptSureComponent } from "components/order-management/medication-name-description-scriptsure/medication-name-description-scriptsure";
import { MedicationStrengthSelectorScripsureComponent } from "components/order-management/medication-strength-selector-scriptsure/medication-strength-selector-scriptsure";
import { MultiOptionComponent } from "components/order-management/multi-option/multi-option";
import { WrappedTextComponent } from "components/order-management/om-details/wrapped-text/wrapped-text";
import { OrderManagementComponentsModule } from "components/order-management/order-management.module";
import { OrderingProviderComponent } from "components/order-management/ordering-provider/ordering-provider";
import { Quantity } from "components/order-management/quantity/quantity";
import { RadioGroupComponent } from "components/order-management/radio-group/radio-group";
import { ReasonForRespiteComponent } from "components/order-management/reason-for-respite/reason-for-respite";
import { ReasonsForGIPComponent } from "components/order-management/reasons-for-gip/reasons-for-gip";
import { ProviderNotesComponent } from "components/order-management/text-area/text-area";
import { OrderTextFieldComponent } from "components/order-management/text-field/text-field";
import { VisitFrequencyDescription } from "components/order-management/visit-frequency-description/visit-frequency-description";
import { IonicPageModule } from "ionic-angular";
import { AddOrder } from "pages/orders-entry-om/add-order/add-order";
import CancelOrder from "pages/orders-entry-om/cancel-order/cancel-order";
import DiscontinueOrder from "pages/orders-entry-om/discontinue-order/discontinue-order";
import { UtcDateTimeZonePipe } from "pipes/output-formatters/utc-date-timezone.pipe";
import { NciAddendumsService } from "providers/nci-addendums/nci-addendums-service";
import { NciIndicatorsService } from "providers/nci-indicators/nci-indicators-service";
import { AuthorizationHttpInterceptor } from "../../../app/authorization/AuthorizationHttpInterceptor";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { ComponentsModule } from "../../../components/components.module";
import { ConfigurableCardsModule } from "../../../components/configurable/cards/configurable-cards.module";
import { ConfigurableInputsModule } from "../../../components/configurable/inputs/configurable-inputs.module";
import { PatientLocationComponent } from "../../../components/order-management/patient-location/patient-location";
import { ToolsModule } from "../../../components/tools/tools.module";
import { NavigationModule } from "../../../navigation/navigation.module";
import { OrderDataService } from "../../../providers/order-data-service/order-data-service";
import AddEditMARDetails from "../add-edit-mar-details/add-edit-mar-details";
import { NotImplemented } from "../add-order/not-implemented.component";
import ESignOrder from "../e-sign/e-sign-order";
import EditHospiceCoverage from "../edit-hospice-coverage/edit-hospice-coverage";
import RejectOrder from "../provider-panel/reject-order/reject-order";
import ReadBackAndVerified from "../read-back-and-verified/read-back-and-verified";
import { OrderEntryOMPage } from "./order-entry-om";

@NgModule({
  entryComponents: [
    AddEditMARDetails,
    AddOrder,
    CancelOrder,
    CareLocationComponent,
    CareLocationTypeComponent,
    CurrentDiagnosisComponent,
    DatePickerComponent,
    DiscontinueOrder,
    EditHospiceCoverage,
    ESignOrder,
    FileUploadComponent,
    LevelOfCareComponent,
    Quantity,
    VisitFrequencyDescription,
    MARDetailsComponent,
    MedicationIngredientsScriptsureComponent,
    MedicationNameDescriptionScriptSureComponent,
    MedicationStrengthSelectorScripsureComponent,
    MultiOptionComponent,
    NotImplemented,
    OrderingDropdownComponent,
    OrderingProviderComponent,
    OrderingSearchInputComponent,
    OrderTextFieldComponent,
    PatientLocationComponent,
    ProviderNotesComponent,
    RadioGroupComponent,
    ReasonForRespiteComponent,
    ReasonsForGIPComponent,
    RejectOrder,
    MARDetailsComponent,
    VerificationComponent,
    WrappedTextComponent,
    DisciplineComponent,
    ReadBackAndVerified,
  ],
  declarations: [
    AddEditMARDetails,
    AddOrder,
    CancelOrder,
    DiscontinueOrder,
    EditHospiceCoverage,
    ESignOrder,
    NotImplemented,
    OrderEntryOMPage,
    RejectOrder,
    ReadBackAndVerified,
  ],
  imports: [
    CommonComponentsModule,
    ComponentsModule,
    ConfigurableCardsModule,
    ConfigurableInputsModule,
    EPrescribeComponentModule,
    HttpClientModule,
    IonicPageModule.forChild(OrderEntryOMPage),
    NavigationModule,
    NgbTimepickerModule,
    NgSelectModule,
    OrderManagementComponentsModule,
    ToolsModule,
    TranslateModule.forChild(),
  ],
  providers: [
    OrderDataService,
    NciAddendumsService,
    NciIndicatorsService,
    UtcDateTimeZonePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationHttpInterceptor,
      multi: true,
    },
  ],
})
export class OrderEntryOMPageModule {}



// WEBPACK FOOTER //
// ./src/pages/orders-entry-om/orders-entry-om/order-entry-om.module.ts